<div class="content" [class.mobile]="isMobile()" [class.tablet]="isTablet()">
  <div [class.desktop-main]="isDesktop()">
    <div>
      @if (filteredPlants()) {
        <div class="found-wrapper">
          @if (assetCount() > 1) {
            <h3>
              {{ assetCount() }} {{ i18n.langString("equipments_found") }}
            </h3>
          }
          @if (assetCount() === 1) {
            <h3>1 {{ i18n.langString("equipment_found") }}</h3>
          }
          @if (
            assetCount() === 0 &&
            bcGroupedPlants().length === 0 &&
            sumCritical() === 0 &&
            sumWarning() === 0 &&
            sumInactive() === 0 &&
            sumWorking() === 0
          ) {
            <h3>{{ i18n.langString("no_equipments_found") }}</h3>
            <h5 class="marginTop24">
              {{ i18n.langString("no_equipments_found2") }}
            </h5>
          }
        </div>
      }
    </div>
    <div class="nz-multiple-status-reports nz-multiple-reports-left">
      @if (allWorking()) {
        <nz-alert
          nzType="success"
          class="nz-status-report"
          [nzMessage]="allfineTemplate"
        ></nz-alert>

        <ng-template #allfineTemplate>
          <i nz-icon nzType="icons:status-check" class="svg-icon fillgreen"></i>
          <span class="body-bold">
            {{ i18n.langString("all_equipments_working_fine") }}
          </span>
        </ng-template>
      }
    </div>

    <div
      class="nz-multiple-status-reports first-status-report nz-multiple-reports-left"
    >
      @if (
        assetCount() > 0 &&
        (sumCritical() > 0 ||
          sumWarning() > 0 ||
          sumInactive() > 0 ||
          sumWorking() > 0 ||
          sumArchived() > 0)
      ) {
        @if (sumInactive() > 0) {
          <nz-alert
            nzType="info"
            class="nz-status-report"
            [nzMessage]="inActiveTemplate"
            (click)="statusClick(filterStatusEnum.inactive)"
          ></nz-alert>
          <ng-template #inActiveTemplate>
            <a>
              <i
                nz-icon
                nzType="icons:cross-circle"
                class="svg-icon fillblackcoral"
              ></i>
              <span class="body-bold">
                {{ sumInactive() }} {{ i18n.langString("in_active") }}
              </span>
            </a>
          </ng-template>
        }

        @if (sumCritical() > 0) {
          <nz-alert
            nzType="error"
            class="nz-status-report"
            [nzMessage]="errorTemplate"
            (click)="statusClick(filterStatusEnum.critical)"
          ></nz-alert>
          <ng-template #errorTemplate>
            <a>
              <i
                nz-icon
                nzType="icons:status-exclamation-triangle"
                class="svg-icon fillred"
              ></i>
              <span class="body-bold">
                {{ sumCritical() }} {{ i18n.langString("critical") }}
              </span>
            </a>
          </ng-template>
        }

        @if (sumWarning() > 0) {
          <nz-alert
            nzType="warning"
            class="nz-status-report"
            [nzMessage]="warningTemplate"
            (click)="statusClick(filterStatusEnum.warning)"
          ></nz-alert>
          <ng-template #warningTemplate>
            <a>
              <i
                nz-icon
                nzType="icons:status-exclamation-octagon"
                class="svg-icon fillorange"
              ></i>
              <span class="body-bold">
                {{ sumWarning() }} {{ i18n.langString("warning") }}
              </span>
            </a>
          </ng-template>
        }

        @if (sumWorking() > 0) {
          <nz-alert
            nzType="success"
            class="nz-status-report"
            [nzMessage]="otherfineTemplate"
            (click)="statusClick(filterStatusEnum.working)"
          ></nz-alert>
          <ng-template #otherfineTemplate>
            <a>
              <i
                nz-icon
                nzType="icons:status-check"
                class="svg-icon fillgreen"
              ></i>
              <span class="body-bold">
                {{ sumWorking() }} {{ i18n.langString("working_fine") }}
              </span>
            </a>
          </ng-template>
        }
        @if (sumArchived() > 0) {
          <nz-alert
            class="nz-status-report ant-alert-archived"
            [nzMessage]="archivedTemplate"
            (click)="statusClick(filterStatusEnum.archived)"
          ></nz-alert>
          <ng-template #archivedTemplate>
            <a
              ><i nz-icon nzType="icons:folder" class="svg-icon"></i>
              <span class="body-bold">
                {{ sumArchived() }} {{ i18n.langString("deinstalled") }}</span
              ></a
            >
          </ng-template>
        }
      }
    </div>
    @for (breadcrumbcluster of bcGroupedPlants(); track $index) {
      <app-breadcrumbs [object]="breadcrumbcluster[0]"></app-breadcrumbs>
      @for (plant of breadcrumbcluster; track $index) {
        @if (
          plant.Critical.length === 0 &&
          plant.Warning.length === 0 &&
          plant.InActive.length === 0 &&
          !plant.filtered
        ) {
          <app-card [plant]="plant" [fine]="true"></app-card>
        }
        @if (
          (plant.Critical.length > 0 ||
            plant.Warning.length > 0 ||
            plant.InActive.length > 0) &&
          ((plant.Critical.length +
            plant.Warning.length +
            plant.InActive.length <
            6 &&
            isDesktop()) ||
            (plant.Critical.length +
              plant.Warning.length +
              plant.InActive.length <
              4 &&
              !isDesktop())) &&
          !plant.filtered
        ) {
          <app-card [plant]="plant" [fine]="false">
            <!-- InActive Section -->
            @if (plant.InActive.length > 0) {
              <nz-alert
                nzType="info"
                class="nz-status-report noMargin"
                [class.center]="!isDesktop()"
                [nzMessage]="inActiveTemplate"
              ></nz-alert>
              <ng-template #inActiveTemplate>
                <i
                  nz-icon
                  nzType="icons:cross-circle"
                  class="fillblackcoral"
                ></i>
                @if (plant.InActive.length === 1) {
                  <span class="body-bold">
                    {{ plant.InActive.length }}
                    {{ i18n.langString("in_active_sensor") }}
                  </span>
                }
                @if (plant.InActive.length > 1) {
                  <span class="body-bold">
                    {{ plant.InActive.length }}
                    {{ i18n.langString("in_active_sensors") }}
                  </span>
                }
              </ng-template>

              @for (building of plant.children; track $index) {
                @if (building.InActive.length > 0) {
                  <div class="card-layer">
                    <h2>{{ building.objectName }}</h2>
                    @for (equipment of building.children; track $index) {
                      @if (equipment.InActive.length > 0) {
                        <span class="regular black-coral-text">{{
                          equipment.objectName
                        }}</span>
                        <div class="list-equipment-wrapper">
                          @for (asset of equipment.InActive; track $index) {
                            <app-asset-nav-button
                              [asset]="asset"
                              svg_icon="icons:cross-circle"
                            >
                              {{ asset.objectName | nameSlice }}
                            </app-asset-nav-button>
                          }
                        </div>
                      }
                    }
                  </div>
                }
              }
            }

            <!-- Critical Section -->
            @if (plant.Critical.length > 0) {
              <nz-alert
                nzType="error"
                class="nz-status-report noMargin"
                [class.center]="!isDesktop()"
                [nzMessage]="errorTemplate"
              ></nz-alert>
              <ng-template #errorTemplate>
                <i
                  nz-icon
                  nzType="icons:status-exclamation-triangle"
                  class="fillred"
                ></i>
                <span class="body-bold">
                  {{ plant.Critical.length }}
                  {{ i18n.langString("critical_equipments") }}
                </span>
              </ng-template>

              @for (building of plant.children; track $index) {
                @if (building.Critical.length > 0) {
                  <div class="card-layer">
                    <h2>{{ building.objectName }}</h2>
                    @for (equipment of building.children; track $index) {
                      @if (equipment.Critical.length > 0) {
                        <span class="regular black-coral-text">{{
                          equipment.objectName
                        }}</span>
                        <div class="list-equipment-wrapper">
                          @for (asset of equipment.Critical; track $index) {
                            <app-asset-nav-button
                              [asset]="asset"
                              svg_icon="icons:status-exclamation-triangle"
                            >
                              {{ asset.objectName | nameSlice }}
                            </app-asset-nav-button>
                          }
                        </div>
                      }
                    }
                  </div>
                }
              }
            }

            <!-- Warning Section -->
            @if (plant.Warning.length > 0) {
              <nz-alert
                nzType="warning"
                class="nz-status-report noMargin"
                [class.center]="!isDesktop()"
                [nzMessage]="warningTemplate"
              ></nz-alert>
              <ng-template #warningTemplate>
                <i
                  nz-icon
                  nzType="icons:status-exclamation-octagon"
                  class="fillorange"
                ></i>
                @if (plant.Warning.length === 1) {
                  <span class="body-bold">
                    {{ plant.Warning.length }}
                    {{ i18n.langString("warning_equipment") }}
                  </span>
                }
                @if (plant.Warning.length > 1) {
                  <span class="body-bold">
                    {{ plant.Warning.length }}
                    {{ i18n.langString("warning_equipments") }}
                  </span>
                }
              </ng-template>

              @for (building of plant.children; track $index) {
                @if (building.Warning.length > 0) {
                  <div class="card-layer">
                    <h2>{{ building.objectName }}</h2>
                    @for (equipment of building.children; track $index) {
                      @if (equipment.Warning.length > 0) {
                        <span class="regular black-coral-text">{{
                          equipment.objectName
                        }}</span>
                        <div class="list-equipment-wrapper">
                          @for (asset of equipment.Warning; track $index) {
                            <app-asset-nav-button
                              [asset]="asset"
                              svg_icon="icons:status-exclamation-octagon"
                            >
                              {{ asset.objectName | nameSlice }}
                            </app-asset-nav-button>
                          }
                        </div>
                      }
                    }
                  </div>
                }
              }
            }
          </app-card>
        }
        @if (
          (plant.Critical.length > 0 ||
            plant.Warning.length > 0 ||
            plant.InActive.length > 0) &&
          ((plant.Critical.length +
            plant.Warning.length +
            plant.InActive.length >=
            6 &&
            isDesktop()) ||
            (plant.Critical.length +
              plant.Warning.length +
              plant.InActive.length >=
              4 &&
              !isDesktop())) &&
          !plant.filtered
        ) {
          <app-card [plant]="plant" [fine]="false">
            <!-- InActive Section -->
            @if (plant.InActive.length > 0) {
              <nz-alert
                nzType="info"
                class="nz-status-report noMargin content-aligment-center"
                [class.center]="!isDesktop()"
                [nzMessage]="inActiveTemplate"
              ></nz-alert>
              <ng-template #inActiveTemplate>
                <i
                  nz-icon
                  nzType="icons:cross-circle"
                  class="fillblackcoral"
                ></i>
                @if (plant.InActive.length === 1) {
                  <span class="body-bold">
                    {{ plant.InActive.length }}
                    {{ i18n.langString("in_active_sensor") }}
                  </span>
                }
                @if (plant.InActive.length > 1) {
                  <span class="body-bold">
                    {{ plant.InActive.length }}
                    {{ i18n.langString("in_active_sensors") }}
                  </span>
                }
              </ng-template>
              <div class="card-layer">
                <div class="list-equipment-wrapper">
                  <app-asset-nav-button
                    [inactiveStatus]="true"
                    svg_icon="icons:eye"
                    (clickEvent)="onClick(plant, filterStatusEnum.inactive)"
                  >
                    {{ i18n.langString("show_inactive_sensors") }}
                  </app-asset-nav-button>
                </div>
              </div>
            }

            <!-- Critical Section -->
            @if (plant.Critical.length > 0) {
              <nz-alert
                nzType="error"
                class="nz-status-report noMargin"
                [class.center]="!isDesktop()"
                [nzMessage]="errorTemplate"
              ></nz-alert>
              <ng-template #errorTemplate>
                <i
                  nz-icon
                  nzType="icons:status-exclamation-triangle"
                  class="fillred"
                ></i>
                <span class="body-bold">
                  {{ plant.Critical.length }}
                  {{ i18n.langString("critical_equipments") }}
                </span>
              </ng-template>
              <div class="card-layer">
                <div class="list-equipment-wrapper">
                  <app-asset-nav-button
                    [criticalStatus]="true"
                    svg_icon="icons:eye"
                    (clickEvent)="onClick(plant, filterStatusEnum.critical)"
                  >
                    {{ i18n.langString("show_critical_equipments") }}
                  </app-asset-nav-button>
                </div>
              </div>
            }

            <!-- Warning Section -->
            @if (plant.Warning.length > 0) {
              <nz-alert
                nzType="warning"
                class="nz-status-report noMargin"
                [class.center]="!isDesktop()"
                [nzMessage]="warningTemplate"
              ></nz-alert>
              <ng-template #warningTemplate>
                <i
                  nz-icon
                  nzType="icons:status-exclamation-octagon"
                  class="fillorange"
                ></i>
                @if (plant.Warning.length === 1) {
                  <span class="body-bold">
                    {{ plant.Warning.length }}
                    {{ i18n.langString("warning_equipment") }}
                  </span>
                }
                @if (plant.Warning.length > 1) {
                  <span class="body-bold">
                    {{ plant.Warning.length }}
                    {{ i18n.langString("warning_equipments") }}
                  </span>
                }
              </ng-template>
              <div class="card-layer">
                <div class="list-equipment-wrapper">
                  <app-asset-nav-button
                    [warningStatus]="true"
                    svg_icon="icons:eye"
                    (clickEvent)="onClick(plant, filterStatusEnum.warning)"
                  >
                    {{ i18n.langString("show_warning_equipments") }}
                  </app-asset-nav-button>
                </div>
              </div>
            }
          </app-card>
        }
        @if (plant.filtered) {
          <app-card [plant]="plant" [fine]="false">
            @for (bcCluster of assetsGroupBy(plant); track $index) {
              <app-breadcrumbs
                [object]="bcCluster[0]"
                [searchTealText]="true"
                [shorten]="2"
              ></app-breadcrumbs>

              <div class="search-result-wrapper">
                @for (asset of bcCluster; track $index) {
                  <app-asset-nav-button
                    [asset]="asset"
                    [svg_icon]="statusChecked(asset)"
                  >
                    {{ asset.objectName | nameSlice }}
                  </app-asset-nav-button>
                }
              </div>
            }
          </app-card>
        }
      }
    }
    @if (loading()) {
      <div class="spinner"></div>
    }
  </div>
</div>
